export default "__VITE_ASSET__BKZNty4F__"